// Server-anchored clock. Encapsulates request-signing time drift behind an
// instance so consumers only see `clock.now()` and the offset is unreachable
// from outside the class.
//
//   syncOffset(serverSeconds):  set the drift from a server-side seconds
//                               timestamp. Only update when |drift| > 10s;
//                               sub-10s
//                               noise comes from network latency, not real
//                               skew.
//   now():                      server-aligned millisecond timestamp; use
//                               this wherever a `Date.now()` would
//                               otherwise be signed into a request ticket.

class Clock {
  #offset = 0;

  syncOffset(serverSeconds: number): void {
    const next = Date.now() - serverSeconds * 1000;
    if (Math.abs(next) > 10000) {
      this.#offset = next;
    }
  }

  now(): number {
    return Date.now() - this.#offset;
  }

  // Test-only — syncOffset ignores sub-10s deltas by design, so specs have
  // no public path back to a zero offset between tests.
  __resetForTests(): void {
    this.#offset = 0;
  }
}

export const clock = new Clock();
